import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { bildirimService } from '../api/dbService';
import PageLayout from '../components/PageLayout';
import LoadingSpinner from '../components/LoadingSpinner';

export default function Notifications() {
  const [bildirimler, setBildirimler] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    bildirimService.getBildirimler()
      .then(res => setBildirimler(res.data || []))
      .finally(() => setLoading(false));
  }, []);

  async function handleOku(id) {
    await bildirimService.okuOlarak(id);
    setBildirimler(prev => prev.map(b => b.id === id ? { ...b, okundu: 1 } : b));
  }

  async function handleTumuOku() {
    await bildirimService.tumuOku();
    setBildirimler(prev => prev.map(b => ({ ...b, okundu: 1 })));
    toast.success('Tümü okundu olarak işaretlendi');
  }

  const TIP_RENK = { info: 'primary', warning: 'warning', error: 'danger', success: 'success' };

  if (loading) return <PageLayout><LoadingSpinner /></PageLayout>;

  return (
    <PageLayout>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0 fw-semibold">Bildirimler</h5>
        {bildirimler.some(b => !b.okundu) && (
          <button className="btn btn-outline-secondary btn-sm" onClick={handleTumuOku}>Tümünü Oku</button>
        )}
      </div>

      {bildirimler.length === 0 ? (
        <div className="text-center text-muted py-5">
          <i className="fas fa-bell-slash fa-3x mb-3 d-block opacity-25"></i>
          <p>Bildirim yok</p>
        </div>
      ) : (
        <div className="d-flex flex-column gap-2">
          {bildirimler.map(b => (
            <div key={b.id} className={`card border-${TIP_RENK[b.tip] || 'primary'} ${!b.okundu ? 'border-2' : 'opacity-75'}`}>
              <div className="card-body py-2 d-flex justify-content-between align-items-start">
                <div>
                  <div className="fw-semibold small">{b.baslik}</div>
                  <div className="text-muted small">{b.mesaj}</div>
                  <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                    {new Date(b.olusturma_tarihi).toLocaleString('tr-TR')}
                  </div>
                </div>
                {!b.okundu && (
                  <button className="btn btn-sm btn-outline-secondary ms-2" onClick={() => handleOku(b.id)}>Oku</button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </PageLayout>
  );
}
